import { awsExpectUnion as __expectUnion, loadRestJsonErrorCode, parseJsonBody as parseBody, parseJsonErrorBody as parseErrorBody, } from "@aws-sdk/core";
import { HttpRequest as __HttpRequest } from "@smithy/protocol-http";
import { _json, collectBody, decorateServiceException as __decorateServiceException, expectBoolean as __expectBoolean, expectLong as __expectLong, expectNonNull as __expectNonNull, expectString as __expectString, parseRfc3339DateTimeWithOffset as __parseRfc3339DateTimeWithOffset, take, withBaseException, } from "@smithy/smithy-client";
import { v4 as generateIdempotencyToken } from "uuid";
import { AccessDeniedException, AttributeValue, ConflictException, ContextDefinition, EntitiesDefinition, InternalServerException, InvalidStateException, ResourceNotFoundException, ServiceQuotaExceededException, ThrottlingException, TooManyTagsException, ValidationException, } from "../models/models_0";
import { VerifiedPermissionsServiceException as __BaseException } from "../models/VerifiedPermissionsServiceException";
export const se_BatchGetPolicyCommand = async (input, context) => {
    const headers = sharedHeaders("BatchGetPolicy");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_BatchIsAuthorizedCommand = async (input, context) => {
    const headers = sharedHeaders("BatchIsAuthorized");
    let body;
    body = JSON.stringify(se_BatchIsAuthorizedInput(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_BatchIsAuthorizedWithTokenCommand = async (input, context) => {
    const headers = sharedHeaders("BatchIsAuthorizedWithToken");
    let body;
    body = JSON.stringify(se_BatchIsAuthorizedWithTokenInput(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_CreateIdentitySourceCommand = async (input, context) => {
    const headers = sharedHeaders("CreateIdentitySource");
    let body;
    body = JSON.stringify(se_CreateIdentitySourceInput(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_CreatePolicyCommand = async (input, context) => {
    const headers = sharedHeaders("CreatePolicy");
    let body;
    body = JSON.stringify(se_CreatePolicyInput(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_CreatePolicyStoreCommand = async (input, context) => {
    const headers = sharedHeaders("CreatePolicyStore");
    let body;
    body = JSON.stringify(se_CreatePolicyStoreInput(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_CreatePolicyTemplateCommand = async (input, context) => {
    const headers = sharedHeaders("CreatePolicyTemplate");
    let body;
    body = JSON.stringify(se_CreatePolicyTemplateInput(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteIdentitySourceCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteIdentitySource");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeletePolicyCommand = async (input, context) => {
    const headers = sharedHeaders("DeletePolicy");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeletePolicyStoreCommand = async (input, context) => {
    const headers = sharedHeaders("DeletePolicyStore");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeletePolicyTemplateCommand = async (input, context) => {
    const headers = sharedHeaders("DeletePolicyTemplate");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetIdentitySourceCommand = async (input, context) => {
    const headers = sharedHeaders("GetIdentitySource");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetPolicyCommand = async (input, context) => {
    const headers = sharedHeaders("GetPolicy");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetPolicyStoreCommand = async (input, context) => {
    const headers = sharedHeaders("GetPolicyStore");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetPolicyTemplateCommand = async (input, context) => {
    const headers = sharedHeaders("GetPolicyTemplate");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetSchemaCommand = async (input, context) => {
    const headers = sharedHeaders("GetSchema");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_IsAuthorizedCommand = async (input, context) => {
    const headers = sharedHeaders("IsAuthorized");
    let body;
    body = JSON.stringify(se_IsAuthorizedInput(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_IsAuthorizedWithTokenCommand = async (input, context) => {
    const headers = sharedHeaders("IsAuthorizedWithToken");
    let body;
    body = JSON.stringify(se_IsAuthorizedWithTokenInput(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_ListIdentitySourcesCommand = async (input, context) => {
    const headers = sharedHeaders("ListIdentitySources");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_ListPoliciesCommand = async (input, context) => {
    const headers = sharedHeaders("ListPolicies");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_ListPolicyStoresCommand = async (input, context) => {
    const headers = sharedHeaders("ListPolicyStores");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_ListPolicyTemplatesCommand = async (input, context) => {
    const headers = sharedHeaders("ListPolicyTemplates");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_ListTagsForResourceCommand = async (input, context) => {
    const headers = sharedHeaders("ListTagsForResource");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutSchemaCommand = async (input, context) => {
    const headers = sharedHeaders("PutSchema");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_TagResourceCommand = async (input, context) => {
    const headers = sharedHeaders("TagResource");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_UntagResourceCommand = async (input, context) => {
    const headers = sharedHeaders("UntagResource");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_UpdateIdentitySourceCommand = async (input, context) => {
    const headers = sharedHeaders("UpdateIdentitySource");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_UpdatePolicyCommand = async (input, context) => {
    const headers = sharedHeaders("UpdatePolicy");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_UpdatePolicyStoreCommand = async (input, context) => {
    const headers = sharedHeaders("UpdatePolicyStore");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_UpdatePolicyTemplateCommand = async (input, context) => {
    const headers = sharedHeaders("UpdatePolicyTemplate");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const de_BatchGetPolicyCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_BatchGetPolicyOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_BatchIsAuthorizedCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_BatchIsAuthorizedOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_BatchIsAuthorizedWithTokenCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_BatchIsAuthorizedWithTokenOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_CreateIdentitySourceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_CreateIdentitySourceOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_CreatePolicyCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_CreatePolicyOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_CreatePolicyStoreCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_CreatePolicyStoreOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_CreatePolicyTemplateCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_CreatePolicyTemplateOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DeleteIdentitySourceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DeletePolicyCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DeletePolicyStoreCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DeletePolicyTemplateCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetIdentitySourceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetIdentitySourceOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetPolicyCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetPolicyOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetPolicyStoreCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetPolicyStoreOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetPolicyTemplateCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetPolicyTemplateOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetSchemaCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetSchemaOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_IsAuthorizedCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_IsAuthorizedWithTokenCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_ListIdentitySourcesCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_ListIdentitySourcesOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_ListPoliciesCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_ListPoliciesOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_ListPolicyStoresCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_ListPolicyStoresOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_ListPolicyTemplatesCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_ListPolicyTemplatesOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_ListTagsForResourceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_PutSchemaCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_PutSchemaOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_TagResourceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_UntagResourceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_UpdateIdentitySourceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_UpdateIdentitySourceOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_UpdatePolicyCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_UpdatePolicyOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_UpdatePolicyStoreCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_UpdatePolicyStoreOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_UpdatePolicyTemplateCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_UpdatePolicyTemplateOutput(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
const de_CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "AccessDeniedException":
        case "com.amazonaws.verifiedpermissions#AccessDeniedException":
            throw await de_AccessDeniedExceptionRes(parsedOutput, context);
        case "InternalServerException":
        case "com.amazonaws.verifiedpermissions#InternalServerException":
            throw await de_InternalServerExceptionRes(parsedOutput, context);
        case "ThrottlingException":
        case "com.amazonaws.verifiedpermissions#ThrottlingException":
            throw await de_ThrottlingExceptionRes(parsedOutput, context);
        case "ValidationException":
        case "com.amazonaws.verifiedpermissions#ValidationException":
            throw await de_ValidationExceptionRes(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.verifiedpermissions#ResourceNotFoundException":
            throw await de_ResourceNotFoundExceptionRes(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.verifiedpermissions#ConflictException":
            throw await de_ConflictExceptionRes(parsedOutput, context);
        case "ServiceQuotaExceededException":
        case "com.amazonaws.verifiedpermissions#ServiceQuotaExceededException":
            throw await de_ServiceQuotaExceededExceptionRes(parsedOutput, context);
        case "InvalidStateException":
        case "com.amazonaws.verifiedpermissions#InvalidStateException":
            throw await de_InvalidStateExceptionRes(parsedOutput, context);
        case "TooManyTagsException":
        case "com.amazonaws.verifiedpermissions#TooManyTagsException":
            throw await de_TooManyTagsExceptionRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return throwDefaultError({
                output,
                parsedBody,
                errorCode,
            });
    }
};
const de_AccessDeniedExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new AccessDeniedException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_ConflictExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new ConflictException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InternalServerExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InternalServerException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InvalidStateExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InvalidStateException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_ResourceNotFoundExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new ResourceNotFoundException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_ServiceQuotaExceededExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new ServiceQuotaExceededException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_ThrottlingExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new ThrottlingException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_TooManyTagsExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new TooManyTagsException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_ValidationExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new ValidationException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const se_AttributeValue = (input, context) => {
    return AttributeValue.visit(input, {
        boolean: (value) => ({ boolean: value }),
        decimal: (value) => ({ decimal: value }),
        entityIdentifier: (value) => ({ entityIdentifier: _json(value) }),
        ipaddr: (value) => ({ ipaddr: value }),
        long: (value) => ({ long: value }),
        record: (value) => ({ record: se_RecordAttribute(value, context) }),
        set: (value) => ({ set: se_SetAttribute(value, context) }),
        string: (value) => ({ string: value }),
        _: (name, value) => ({ [name]: value }),
    });
};
const se_BatchIsAuthorizedInput = (input, context) => {
    return take(input, {
        entities: (_) => se_EntitiesDefinition(_, context),
        policyStoreId: [],
        requests: (_) => se_BatchIsAuthorizedInputList(_, context),
    });
};
const se_BatchIsAuthorizedInputItem = (input, context) => {
    return take(input, {
        action: _json,
        context: (_) => se_ContextDefinition(_, context),
        principal: _json,
        resource: _json,
    });
};
const se_BatchIsAuthorizedInputList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return se_BatchIsAuthorizedInputItem(entry, context);
    });
};
const se_BatchIsAuthorizedWithTokenInput = (input, context) => {
    return take(input, {
        accessToken: [],
        entities: (_) => se_EntitiesDefinition(_, context),
        identityToken: [],
        policyStoreId: [],
        requests: (_) => se_BatchIsAuthorizedWithTokenInputList(_, context),
    });
};
const se_BatchIsAuthorizedWithTokenInputItem = (input, context) => {
    return take(input, {
        action: _json,
        context: (_) => se_ContextDefinition(_, context),
        resource: _json,
    });
};
const se_BatchIsAuthorizedWithTokenInputList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return se_BatchIsAuthorizedWithTokenInputItem(entry, context);
    });
};
const se_ContextDefinition = (input, context) => {
    return ContextDefinition.visit(input, {
        cedarJson: (value) => ({ cedarJson: value }),
        contextMap: (value) => ({ contextMap: se_ContextMap(value, context) }),
        _: (name, value) => ({ [name]: value }),
    });
};
const se_ContextMap = (input, context) => {
    return Object.entries(input).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = se_AttributeValue(value, context);
        return acc;
    }, {});
};
const se_CreateIdentitySourceInput = (input, context) => {
    return take(input, {
        clientToken: [true, (_) => _ ?? generateIdempotencyToken()],
        configuration: _json,
        policyStoreId: [],
        principalEntityType: [],
    });
};
const se_CreatePolicyInput = (input, context) => {
    return take(input, {
        clientToken: [true, (_) => _ ?? generateIdempotencyToken()],
        definition: _json,
        policyStoreId: [],
    });
};
const se_CreatePolicyStoreInput = (input, context) => {
    return take(input, {
        clientToken: [true, (_) => _ ?? generateIdempotencyToken()],
        deletionProtection: [],
        description: [],
        tags: _json,
        validationSettings: _json,
    });
};
const se_CreatePolicyTemplateInput = (input, context) => {
    return take(input, {
        clientToken: [true, (_) => _ ?? generateIdempotencyToken()],
        description: [],
        policyStoreId: [],
        statement: [],
    });
};
const se_EntitiesDefinition = (input, context) => {
    return EntitiesDefinition.visit(input, {
        cedarJson: (value) => ({ cedarJson: value }),
        entityList: (value) => ({ entityList: se_EntityList(value, context) }),
        _: (name, value) => ({ [name]: value }),
    });
};
const se_EntityAttributes = (input, context) => {
    return Object.entries(input).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = se_AttributeValue(value, context);
        return acc;
    }, {});
};
const se_EntityItem = (input, context) => {
    return take(input, {
        attributes: (_) => se_EntityAttributes(_, context),
        identifier: _json,
        parents: _json,
    });
};
const se_EntityList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return se_EntityItem(entry, context);
    });
};
const se_IsAuthorizedInput = (input, context) => {
    return take(input, {
        action: _json,
        context: (_) => se_ContextDefinition(_, context),
        entities: (_) => se_EntitiesDefinition(_, context),
        policyStoreId: [],
        principal: _json,
        resource: _json,
    });
};
const se_IsAuthorizedWithTokenInput = (input, context) => {
    return take(input, {
        accessToken: [],
        action: _json,
        context: (_) => se_ContextDefinition(_, context),
        entities: (_) => se_EntitiesDefinition(_, context),
        identityToken: [],
        policyStoreId: [],
        resource: _json,
    });
};
const se_RecordAttribute = (input, context) => {
    return Object.entries(input).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = se_AttributeValue(value, context);
        return acc;
    }, {});
};
const se_SetAttribute = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return se_AttributeValue(entry, context);
    });
};
const de_AttributeValue = (output, context) => {
    if (__expectBoolean(output.boolean) !== undefined) {
        return { boolean: __expectBoolean(output.boolean) };
    }
    if (__expectString(output.decimal) !== undefined) {
        return { decimal: __expectString(output.decimal) };
    }
    if (output.entityIdentifier != null) {
        return {
            entityIdentifier: _json(output.entityIdentifier),
        };
    }
    if (__expectString(output.ipaddr) !== undefined) {
        return { ipaddr: __expectString(output.ipaddr) };
    }
    if (__expectLong(output.long) !== undefined) {
        return { long: __expectLong(output.long) };
    }
    if (output.record != null) {
        return {
            record: de_RecordAttribute(output.record, context),
        };
    }
    if (output.set != null) {
        return {
            set: de_SetAttribute(output.set, context),
        };
    }
    if (__expectString(output.string) !== undefined) {
        return { string: __expectString(output.string) };
    }
    return { $unknown: Object.entries(output)[0] };
};
const de_BatchGetPolicyOutput = (output, context) => {
    return take(output, {
        errors: _json,
        results: (_) => de_BatchGetPolicyOutputList(_, context),
    });
};
const de_BatchGetPolicyOutputItem = (output, context) => {
    return take(output, {
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        definition: (_) => _json(__expectUnion(_)),
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyId: __expectString,
        policyStoreId: __expectString,
        policyType: __expectString,
    });
};
const de_BatchGetPolicyOutputList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_BatchGetPolicyOutputItem(entry, context);
    });
    return retVal;
};
const de_BatchIsAuthorizedInputItem = (output, context) => {
    return take(output, {
        action: _json,
        context: (_) => de_ContextDefinition(__expectUnion(_), context),
        principal: _json,
        resource: _json,
    });
};
const de_BatchIsAuthorizedOutput = (output, context) => {
    return take(output, {
        results: (_) => de_BatchIsAuthorizedOutputList(_, context),
    });
};
const de_BatchIsAuthorizedOutputItem = (output, context) => {
    return take(output, {
        decision: __expectString,
        determiningPolicies: _json,
        errors: _json,
        request: (_) => de_BatchIsAuthorizedInputItem(_, context),
    });
};
const de_BatchIsAuthorizedOutputList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_BatchIsAuthorizedOutputItem(entry, context);
    });
    return retVal;
};
const de_BatchIsAuthorizedWithTokenInputItem = (output, context) => {
    return take(output, {
        action: _json,
        context: (_) => de_ContextDefinition(__expectUnion(_), context),
        resource: _json,
    });
};
const de_BatchIsAuthorizedWithTokenOutput = (output, context) => {
    return take(output, {
        principal: _json,
        results: (_) => de_BatchIsAuthorizedWithTokenOutputList(_, context),
    });
};
const de_BatchIsAuthorizedWithTokenOutputItem = (output, context) => {
    return take(output, {
        decision: __expectString,
        determiningPolicies: _json,
        errors: _json,
        request: (_) => de_BatchIsAuthorizedWithTokenInputItem(_, context),
    });
};
const de_BatchIsAuthorizedWithTokenOutputList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_BatchIsAuthorizedWithTokenOutputItem(entry, context);
    });
    return retVal;
};
const de_ContextDefinition = (output, context) => {
    if (__expectString(output.cedarJson) !== undefined) {
        return { cedarJson: __expectString(output.cedarJson) };
    }
    if (output.contextMap != null) {
        return {
            contextMap: de_ContextMap(output.contextMap, context),
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const de_ContextMap = (output, context) => {
    return Object.entries(output).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = de_AttributeValue(__expectUnion(value), context);
        return acc;
    }, {});
};
const de_CreateIdentitySourceOutput = (output, context) => {
    return take(output, {
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        identitySourceId: __expectString,
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyStoreId: __expectString,
    });
};
const de_CreatePolicyOutput = (output, context) => {
    return take(output, {
        actions: _json,
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        effect: __expectString,
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyId: __expectString,
        policyStoreId: __expectString,
        policyType: __expectString,
        principal: _json,
        resource: _json,
    });
};
const de_CreatePolicyStoreOutput = (output, context) => {
    return take(output, {
        arn: __expectString,
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyStoreId: __expectString,
    });
};
const de_CreatePolicyTemplateOutput = (output, context) => {
    return take(output, {
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyStoreId: __expectString,
        policyTemplateId: __expectString,
    });
};
const de_GetIdentitySourceOutput = (output, context) => {
    return take(output, {
        configuration: (_) => _json(__expectUnion(_)),
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        details: _json,
        identitySourceId: __expectString,
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyStoreId: __expectString,
        principalEntityType: __expectString,
    });
};
const de_GetPolicyOutput = (output, context) => {
    return take(output, {
        actions: _json,
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        definition: (_) => _json(__expectUnion(_)),
        effect: __expectString,
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyId: __expectString,
        policyStoreId: __expectString,
        policyType: __expectString,
        principal: _json,
        resource: _json,
    });
};
const de_GetPolicyStoreOutput = (output, context) => {
    return take(output, {
        arn: __expectString,
        cedarVersion: __expectString,
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        deletionProtection: __expectString,
        description: __expectString,
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyStoreId: __expectString,
        tags: _json,
        validationSettings: _json,
    });
};
const de_GetPolicyTemplateOutput = (output, context) => {
    return take(output, {
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        description: __expectString,
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyStoreId: __expectString,
        policyTemplateId: __expectString,
        statement: __expectString,
    });
};
const de_GetSchemaOutput = (output, context) => {
    return take(output, {
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        namespaces: _json,
        policyStoreId: __expectString,
        schema: __expectString,
    });
};
const de_IdentitySourceItem = (output, context) => {
    return take(output, {
        configuration: (_) => _json(__expectUnion(_)),
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        details: _json,
        identitySourceId: __expectString,
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyStoreId: __expectString,
        principalEntityType: __expectString,
    });
};
const de_IdentitySources = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_IdentitySourceItem(entry, context);
    });
    return retVal;
};
const de_ListIdentitySourcesOutput = (output, context) => {
    return take(output, {
        identitySources: (_) => de_IdentitySources(_, context),
        nextToken: __expectString,
    });
};
const de_ListPoliciesOutput = (output, context) => {
    return take(output, {
        nextToken: __expectString,
        policies: (_) => de_PolicyList(_, context),
    });
};
const de_ListPolicyStoresOutput = (output, context) => {
    return take(output, {
        nextToken: __expectString,
        policyStores: (_) => de_PolicyStoreList(_, context),
    });
};
const de_ListPolicyTemplatesOutput = (output, context) => {
    return take(output, {
        nextToken: __expectString,
        policyTemplates: (_) => de_PolicyTemplatesList(_, context),
    });
};
const de_PolicyItem = (output, context) => {
    return take(output, {
        actions: _json,
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        definition: (_) => _json(__expectUnion(_)),
        effect: __expectString,
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyId: __expectString,
        policyStoreId: __expectString,
        policyType: __expectString,
        principal: _json,
        resource: _json,
    });
};
const de_PolicyList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_PolicyItem(entry, context);
    });
    return retVal;
};
const de_PolicyStoreItem = (output, context) => {
    return take(output, {
        arn: __expectString,
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        description: __expectString,
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyStoreId: __expectString,
    });
};
const de_PolicyStoreList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_PolicyStoreItem(entry, context);
    });
    return retVal;
};
const de_PolicyTemplateItem = (output, context) => {
    return take(output, {
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        description: __expectString,
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyStoreId: __expectString,
        policyTemplateId: __expectString,
    });
};
const de_PolicyTemplatesList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_PolicyTemplateItem(entry, context);
    });
    return retVal;
};
const de_PutSchemaOutput = (output, context) => {
    return take(output, {
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        namespaces: _json,
        policyStoreId: __expectString,
    });
};
const de_RecordAttribute = (output, context) => {
    return Object.entries(output).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = de_AttributeValue(__expectUnion(value), context);
        return acc;
    }, {});
};
const de_SetAttribute = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_AttributeValue(__expectUnion(entry), context);
    });
    return retVal;
};
const de_UpdateIdentitySourceOutput = (output, context) => {
    return take(output, {
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        identitySourceId: __expectString,
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyStoreId: __expectString,
    });
};
const de_UpdatePolicyOutput = (output, context) => {
    return take(output, {
        actions: _json,
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        effect: __expectString,
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyId: __expectString,
        policyStoreId: __expectString,
        policyType: __expectString,
        principal: _json,
        resource: _json,
    });
};
const de_UpdatePolicyStoreOutput = (output, context) => {
    return take(output, {
        arn: __expectString,
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyStoreId: __expectString,
    });
};
const de_UpdatePolicyTemplateOutput = (output, context) => {
    return take(output, {
        createdDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        lastUpdatedDate: (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        policyStoreId: __expectString,
        policyTemplateId: __expectString,
    });
};
const deserializeMetadata = (output) => ({
    httpStatusCode: output.statusCode,
    requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"],
});
const collectBodyString = (streamBody, context) => collectBody(streamBody, context).then((body) => context.utf8Encoder(body));
const throwDefaultError = withBaseException(__BaseException);
const buildHttpRpcRequest = async (context, headers, path, resolvedHostname, body) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const contents = {
        protocol,
        hostname,
        port,
        method: "POST",
        path: basePath.endsWith("/") ? basePath.slice(0, -1) + path : basePath + path,
        headers,
    };
    if (resolvedHostname !== undefined) {
        contents.hostname = resolvedHostname;
    }
    if (body !== undefined) {
        contents.body = body;
    }
    return new __HttpRequest(contents);
};
function sharedHeaders(operation) {
    return {
        "content-type": "application/x-amz-json-1.0",
        "x-amz-target": `VerifiedPermissions.${operation}`,
    };
}
